import HtmlParser from "react-html-parser";
import { responseGet, globalSettings, setBadgeStatusGeneric, isUndNullEmp, lodash, sendMessageCloseCurrentWindowAsync, separatorsNumbersSet } from "../../helpers/settings";
import $ from 'jquery';
import {
    validationBankAccountGetAsync, validationBankGetAsync, validationCollectionCashGetAsync, validationExpenseConceptGetAsync, validationPaymentMethodGetAsync,
    validationSupplierGetAsync, validationTaxesGetAsync
} from '../../helpers/validations';
import { conceptModelGet } from "../../models/expenses/concept";
import { purchaseDetailModelGet, purchaseModelGet } from "../../models/expenses/purchase";

export const purchaseFormDataValidateAsync = async ({
    purchase = purchaseModelGet({}),
    purchaseDetails = [purchaseDetailModelGet()],
    dtPurchaseDetailsId = '',
    purchaseDateInputId = '',
    auth = {},
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'purchaseFormDataValidateAsync';
    let response = responseGet();
    try {
        //#region variables
        response.result = {
            numberErrorSet: '',
            dateErrorSet: '',
            supplierErrorSet: '',
            purchaseNumberErrorSet: '',
            purchaseControlNumberErrorSet: '',
            purchaseDescriptionErrorSet: '',
        };
        const neutralValue = separatorsNumbersSet({
            number: 0.00,
            withDecimals: true,
            consoleLogErrorShow: true,
            subMethod: currentMethod,
        })?.result;
        const purchaseDate = $(`#${purchaseDateInputId}`)?.val();
        const dtPurchaseDetailRows = $(`#${dtPurchaseDetailsId}`)?.DataTable()?.data()?.count();
        //#endregion variables

        //#region inputs
        if (isUndNullEmp({ data: purchase?.number, subMethod: currentMethod, })?.result) {
            response.result.numberErrorSet = globalSettings?.messages?.thisFieldRequired?.[languageId];
            response.isWarning = true;
        }

        if (isUndNullEmp({ data: purchaseDate, subMethod: currentMethod, })?.result ||
            isUndNullEmp({ data: purchase?.date, subMethod: currentMethod, })?.result) {
            response.result.dateErrorSet = globalSettings?.messages?.thisFieldRequired?.[languageId];
            response.isWarning = true;
        }

        if (isUndNullEmp({ data: purchase?.supplierId, subMethod: currentMethod, })?.result) {
            response.result.supplierErrorSet = globalSettings?.messages?.thisFieldRequired?.[languageId];
            response.isWarning = true;
        }

        if (isUndNullEmp({ data: purchase?.invoiceNumber, subMethod: currentMethod, })?.result) {
            response.result.purchaseNumberErrorSet = globalSettings?.messages?.thisFieldRequired?.[languageId];
            response.isWarning = true;
        }

        if (isUndNullEmp({ data: purchase?.invoiceControlNumber, subMethod: currentMethod, })?.result) {
            response.result.purchaseControlNumberErrorSet = globalSettings?.messages?.thisFieldRequired?.[languageId];
            response.isWarning = true;
        }

        if (isUndNullEmp({ data: purchase?.description, subMethod: currentMethod, })?.result || purchase?.description?.trim()?.length <= 0) {
            response.result.purchaseDescriptionErrorSet = globalSettings?.messages?.thisFieldRequired?.[languageId];
            response.isWarning = true;
        }
        //#endregion inputs

        //#region validate concepts (Global)
        purchaseDetails = purchaseDetails?.filter((pd) => pd?.expenseConceptId !== '');
        if (isUndNullEmp({ data: dtPurchaseDetailRows, subMethod: currentMethod, })?.result || dtPurchaseDetailRows <= 0 || purchaseDetails?.length <= 0) {
            response.msgType = 1;
            response.isWarning = true;
            response.msgText = `${globalSettings?.messages?.youMustAddLeastConcept?.[languageId]}<br/>`;
            response.msgText += globalSettings?.messages?.inTheInvoiceDetils?.[languageId];
            //#region old code
            // await sendMessageCloseCurrentWindowAsync({
            //     msgType: response?.msgType,
            //     msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //     closeWindow: false,
            //     urlGoTo: response?.urlGoTo,
            //     auth: auth,
            //     isLogout: false,
            //     languageId: languageId,
            //     subMethod: currentMethod,
            // });
            //#endregion old code
            return response;
        } else {
            //#region Valida concepts (one by one)
            for (let purchaseDetail of purchaseDetails) {
                if (purchaseDetail?.quantity <= 0) {
                    response.msgType = 1;
                    response.isWarning = true;
                    response.msgText = `${globalSettings?.labels?.concept?.[languageId]}: <b>${purchaseDetail?.description}</b><br/>`;
                    response.msgText += `<b>${globalSettings?.labels?.quantity?.[languageId]}</b> ${globalSettings?.messages?.mustBeGreaterThan?.[languageId]} <b>${neutralValue}</b>`;
                    //#region old code
                    // await sendMessageCloseCurrentWindowAsync({
                    //     msgType: response?.msgType,
                    //     msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    //     closeWindow: false,
                    //     urlGoTo: response?.urlGoTo,
                    //     auth: auth,
                    //     isLogout: false,
                    //     languageId: languageId,
                    //     subMethod: currentMethod,
                    // });
                    //#endregion old code
                    return response;
                } else if (purchaseDetail?.price <= 0) {
                    response.msgType = 1;
                    response.isWarning = true;
                    response.msgText = `${globalSettings?.labels?.concept?.[languageId]}: <b>${purchaseDetail?.description}</b><br/>`;
                    response.msgText += `<b>${globalSettings?.labels?.price?.[languageId]}</b> ${globalSettings?.messages?.mustBeGreaterThan?.[languageId]} <b>${neutralValue}</b>`;
                    //#region old code
                    // await sendMessageCloseCurrentWindowAsync({
                    //     msgType: response?.msgType,
                    //     msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    //     closeWindow: false,
                    //     urlGoTo: response?.urlGoTo,
                    //     auth: auth,
                    //     isLogout: false,
                    //     languageId: languageId,
                    //     subMethod: currentMethod,
                    // });
                    //#endregion old code
                    return response;
                }
            };
            //#endregion Valida concepts (one by one)
        }
        //#endregion validate concepts (Global)

        //#region old code
        //#region check tax maximum
        // response = checkTaxMaximum(purchaseDetails, 'purchaseFormDataValidateAsync');
        // if (!response?.isSuccess || response?.isWarning) {
        //     return response;
        // }
        //#endregion check tax maximum
        //#endregion old code
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
        await sendMessageCloseCurrentWindowAsync({
            msgType: response?.msgType,
            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            closeWindow: false,
            urlGoTo: response?.urlGoTo,
            auth: auth,
            isLogout: false,
            languageId: languageId,
            subMethod: currentMethod,
        });
    }
    return response;
}

export const purchaseTaxesGetAsync = async ({ buildingId = '', auth = {}, languageId = 'en', subMethod = '', }) => {
    const currentMethod = 'purchaseTaxesGetAsync';
    let response = responseGet();
    try {
        response = await validationTaxesGetAsync({
            buildingId: buildingId,
            auth: auth,
            limit: 0,
            languageId: languageId,
            subMethod: currentMethod,
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const purchaseSuppliersGetAsync = async ({ buildingId = '', auth = {}, languageId = 'en', subMethod = '', }) => {
    const currentMethod = 'purchaseSuppliersGetAsync';
    let response = responseGet();
    try {
        //#region old code
        // //#region variables
        // //#region response is warning
        // let responseIsWarning = responseGet();
        // responseIsWarning.isWarning = true;
        // responseIsWarning.msgType = 1;
        // responseIsWarning.msgText = 'Method: localPurchaseSuppliersGetAsync<br/>';
        // //#endregion response is warning
        // //#endregion variables

        // //#region suppliers get
        // headerObj = {
        //     headers: {
        //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
        //     },
        // };
        // localData = {
        //     buildingId,
        //     conditionals: [
        //         { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${buildingId}`, },
        //     ],
        //     ordersBy: [
        //         { field: globalSettings?.collections?.properties?.description, value: 'asc', },
        //     ],
        // };
        // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/`, localData, headerObj);
        // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/`, localData, headerObj);
        // response = result.data;

        // if (!response?.isSuccess || response?.isWarning) {
        //     return response;
        // }
        // if (isUndefined(response.result) || isNull(response.result) || response.result.length <= 0) {
        //     responseIsWarning.msgText = `${globalSettings?.messages?.youMustCreateLeastOneSupplier.es}<br/>`;
        //     responseIsWarning.msgText += `${globalSettings?.messages?.goTo.es}: <i class='${globalSettings?.icons?.user}'></i> `;
        //     responseIsWarning.msgText += `<a href='${globalSettings?.app?.backend?.urlSuppliers}'>${globalSettings?.labels?.suppliers.es}</a>`;
        //     return responseIsWarning;
        // }
        // //#endregion suppliers get
        //#endregion old code

        //#region data get
        response = await validationSupplierGetAsync({
            buildingId: buildingId,
            limit: 0,
            auth: auth,
            languageId: languageId,
            subMethod: currentMethod,
        });
        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }
        //#endregion data get
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const purchaseExpenseConceptsGetAsync = async ({ buildingId = '', isConceptsDt = false, auth = {}, languageId = 'en', subMethod = '', }) => {
    const currentMethod = 'purchaseExpenseConceptsGetAsync';
    let response = responseGet();
    try {
        //#region old code
        // //#region variables
        // let localConcepts = [];
        // //#region response is warning
        // let responseIsWarning = responseGet();
        // responseIsWarning.isWarning = true;
        // responseIsWarning.msgType = 1;
        // responseIsWarning.msgText = 'Method: localPurchaseExpenseConceptsGetAsync<br/>';
        // //#endregion response is warning
        // //#endregion variables

        // //#region concepts get
        // headerObj = {
        //     headers: {
        //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
        //     },
        // };
        // localData = {
        //     buildingId,
        //     conditionals: [
        //         { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${buildingId}`, },
        //     ],
        //     ordersBy: [],
        // };
        // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseConcepts}/`, localData, headerObj);
        // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseConcepts}/`, localData, headerObj);
        // response = result.data;

        // if (!response?.isSuccess || response?.isWarning) {
        //     return response;
        // }

        // localConcepts = response.result;

        // if (isUndefined(localConcepts) || isNull(localConcepts) || localConcepts.length <= 0) {
        //     responseIsWarning.msgText = `${globalSettings?.messages?.youMustCreateLeastOneExpenseConcept.es}<br/>`;
        //     responseIsWarning.msgText += `${globalSettings?.messages?.goTo.es}: <i class='${globalSettings?.icons?.fileAltFar}'></i> `;
        //     responseIsWarning.msgText += `<a href='${globalSettings?.app?.backend?.urlExpenseConcepts}'>${globalSettings?.labels?.expenseConcepts.es}</a>`;
        //     return responseIsWarning;
        // }
        //#endregion old code

        //#region variables
        let expenseConcepts = [conceptModelGet({})];
        //#endregion variables

        //#region concepts get
        response = await validationExpenseConceptGetAsync({
            buildingId: buildingId,
            limit: 0,
            auth: auth,
            languageId: languageId,
            subMethod: currentMethod,
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        expenseConcepts = response?.result || [];

        if (isConceptsDt) {
            let expenseConceptsDt = [];
            expenseConcepts?.forEach((detail) => {
                let chkBoxHtl = `<div class='form-check'>`;
                chkBoxHtl += `  <input class='form-check-input' type='checkbox' value='' description='${detail?.description}' id='${detail?.id}'>`;
                chkBoxHtl += `  <label class='form-check-label' for='${detail?.id}'></label>`
                chkBoxHtl += `</div>`

                expenseConceptsDt.push([
                    detail?.id,
                    detail?.description,
                    chkBoxHtl,
                ]);
            });

            response.result = expenseConceptsDt;
        }
        //#endregion concepts get
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const purchaseStatusGet = ({ purchase, showStateLabel = true, htmlParser = true, languageId = 'en', subMethod = '', }) => {
    const currentMethod = 'purchaseStatusGet';
    let response = responseGet();
    try {
        //#region old code
        // response.result = HtmlParser(`   ${globalSettings?.labels?.status.es}: ${setBadgeStatusGeneric(
        //     !isUndefined(purchase.status) ?
        //         (purchase.status === 0 ?
        //             0 : (purchase.status === 1 ?
        //                 2 : (purchase.status === 2 ?
        //                     1 : (purchase.status === 3 ?
        //                         3 : (purchase.status === 4 ? 4 : 5))))) : 4,
        //     !isUndefined(purchase.status) ?
        //         (purchase.status === 0 ?
        //             globalSettings?.labels?.new.es : (purchase.status === 1 ?
        //                 globalSettings?.labels?.notProcessed.es : (purchase.status === 2 ?
        //                     globalSettings?.labels?.partiallyProcessed : (purchase.status === 3 ?
        //                         globalSettings?.labels?.processed : globalSettings?.labels?.canceled)))) : globalSettings?.labels?.new.es)}</b>`);
        //#endregion old code

        //#region methods
        const badGet = setBadgeStatusGeneric({
            type: !isUndNullEmp({ data: purchase?.status, subMethod: currentMethod, })?.result ?
                (purchase?.status === 0 ?
                    0 : (purchase?.status === 1 ?
                        2 : (purchase?.status === 2 ?
                            1 : (purchase?.status === 3 ?
                                3 : (purchase?.status === 4 ? 4 : 5))))) : 4,
            value: !isUndNullEmp({ data: purchase?.status, subMethod: currentMethod, })?.result ?
                (purchase?.status === 0 ?
                    globalSettings?.labels?.new?.[languageId] : (purchase?.status === 1 ?
                        globalSettings?.labels?.notProcessed?.[languageId] : (purchase?.status === 2 ?
                            globalSettings?.labels?.partiallyProcessed?.[languageId] : (purchase?.status === 3 ?
                                globalSettings?.labels?.processed?.[languageId] : globalSettings?.labels?.canceled?.[languageId])))) : globalSettings?.labels?.new?.[languageId],
            subMethod: currentMethod,
        });

        response.result = `${badGet}</b>`;

        if (showStateLabel) {
            response.result = `   ${globalSettings?.labels?.status?.[languageId]}: ${response?.result}`;
        }

        if (htmlParser) {
            response.result = HtmlParser(response.result);
        }
        //#endregion methods
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
        console?.error(response);
    }
    return response;
}

export const purchasePaymentDataGetAsync = async ({ buildingId = '', limit = 1, valueReturn = false, auth = {}, languageId = 'en', subMethod = '', }) => {
    const currentMethod = 'purchasePaymentDataGetAsync';
    let response = responseGet();
    try {
        //#region variables
        const paymentData = {
            collectionCashes: [],
            banks: [],
            bankAccounts: [],
            bankOrigins: [],
            paymentMethods: [],
        };
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region banks get
        //#region old code
        // headerObj = {
        //     headers: {
        //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
        //     },
        // };
        // localData = {
        //     conditionals: [],
        //     ordersBy: [
        //         { field: globalSettings?.collections?.properties?.description, value: 'asc' },
        //     ],
        //     limit: limit,
        // };

        // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBanks}/`, localData, headerObj);
        // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBanks}/`, localData, headerObj);
        // response = result.data;

        // if (!response?.isSuccess || response?.isWarning) {
        //     return response;
        // }

        // if (isUndefined(response.result) || isNull(response.result) || response.result.length <= 0) {
        //     responseIsWarning.msgText = `${globalSettings?.messages?.youMustCreateLeastOneBank.es}<br/>`;
        //     responseIsWarning.msgText += `${globalSettings?.messages?.goTo.es}: <i class='${globalSettings?.icons?.university}'></i> `;
        //     responseIsWarning.msgText += `<a href='${globalSettings?.app?.backend?.urlBanks}'>${globalSettings?.labels?.banks.es}</a>`;
        //     return responseIsWarning;
        // }

        // if (valueReturn) {
        //     response.result = orderBy(response.result, 'description', 'asc');
        //     paymentData.banks = response.result;
        // }
        //#endregion old code

        response = await validationBankGetAsync({
            buildingId: buildingId,
            limit: limit,
            auth: auth,
            languageId: languageId,
            subMethod: currentMethod,
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        if (valueReturn) {
            //#region old code
            //response.result = orderBy(response.result, 'description', 'asc');
            //#endregion old code
            response.result = response?.result?.sort((a, b) => a?.[globalSettings?.collections?.properties?.description] > b?.[globalSettings?.collections?.properties?.description] ? 1 : -1);
            paymentData.banks = response.result;
        }
        //#endregion banks get

        //#region payment methods get
        //#region old code
        // localData = {
        //     conditionals: [],
        //     ordersBy: [
        //         { field: globalSettings?.collections?.properties?.description, value: 'asc' },
        //     ],
        //     limit: limit,
        // };

        // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPaymentMethods}/`, localData, headerObj);
        // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPaymentMethods}/`, localData, headerObj);
        // response = result.data;

        // if (!response?.isSuccess || response?.isWarning) {
        //     return response;
        // }

        // if (isUndefined(response.result) || isNull(response.result) || response.result.length <= 0) {
        //     responseIsWarning.msgText = `${globalSettings?.messages?.youMustCreateLeastOnePaymentMethod.es}<br/>`;
        //     responseIsWarning.msgText += `${globalSettings?.messages?.goTo.es}: <i class='${globalSettings?.icons?.creditCardFas}'></i> `;
        //     responseIsWarning.msgText += `<a href='${globalSettings?.app?.backend?.urlPaymentMethods}'>${globalSettings?.labels?.paymentMethods.es}</a>`;
        //     return responseIsWarning;
        // }

        // if (valueReturn) {
        //     response.result = orderBy(response.result, 'description', 'asc');
        //     paymentData.paymentMethods = response.result;
        // }
        //#endregion old code

        response = await validationPaymentMethodGetAsync({
            buildingId: buildingId,
            limit: limit,
            auth: auth,
            languageId: languageId,
            subMethod: currentMethod,
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        if (valueReturn) {
            //response.result = orderBy(response.result, 'description', 'asc');
            response.result = response?.result?.sort((a, b) => a?.[globalSettings?.collections?.properties?.description] > b?.[globalSettings?.collections?.properties?.description] ? 1 : -1);
            paymentData.paymentMethods = response.result;
        }
        //#endregion payment methods get

        //#region bankAccounts get
        //#region old code
        // localData = {
        //     conditionals: [
        //         { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${buildingId}`, },
        //         { field: globalSettings?.collections?.properties?.inactive, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: false, },
        //     ],
        //     ordersBy: [
        //         { field: globalSettings?.collections?.properties?.number, value: 'asc', },
        //     ],
        //     buildingId,
        //     limit: limit,
        // };

        // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBankAccounts}/`, localData, headerObj);
        // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBankAccounts}/`, localData, headerObj);
        // response = result.data;

        // if (!response?.isSuccess || response?.isWarning) {
        //     return response;
        // }

        // if (isUndefined(response.result) || isNull(response.result) || response.result.length <= 0) {
        //     responseIsWarning.msgText = `${globalSettings?.messages?.youMustCreateLeastOneBankAccount.es}<br/>`;
        //     responseIsWarning.msgText += `${globalSettings?.messages?.goTo.es}: <i class='${globalSettings?.icons?.piggyBank}'></i> `;
        //     responseIsWarning.msgText += `<a href='${globalSettings?.app?.backend?.urlCollectionBankAccounts}'>${globalSettings?.labels?.bankAccounts.es}</a>`;
        //     return responseIsWarning;
        // }

        // if (valueReturn) {
        //     response.result = orderBy(response.result, 'number', 'asc');
        //     paymentData.bankAccounts = response.result;

        //     const localBankAccountsUniq = uniqBy(response.result, 'bankId');
        //     let localBankOrigins = [];

        //     map(localBankAccountsUniq, (detail) => {
        //         localBankOrigins.push(paymentData.banks.filter(({ id }) => id === detail.bankId)[0]);
        //     });

        //     paymentData.bankOrigins = localBankOrigins;
        // }
        //#endregion old code

        response = await validationBankAccountGetAsync({
            buildingId: buildingId,
            limit: 0,
            auth: auth,
            languageId: languageId,
            subMethod: currentMethod
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        if (valueReturn) {
            response.result = response.result?.sort((a, b) => a?.[globalSettings?.collections?.properties?.number] > b?.[globalSettings?.collections?.properties?.number] ? 1 : -1);
            paymentData.bankAccounts = response.result;

            const bankAccountsUniq = lodash?.unique({ data: response?.result, key: globalSettings?.collections?.properties?.bankId, subMethod: currentMethod, })?.result;
            let bankOrigins = [];

            bankAccountsUniq?.forEach((detail) => {
                bankOrigins?.push(paymentData?.banks?.filter(({ id }) => id === detail?.bankId)?.[0]);
            });

            paymentData.bankOrigins = bankOrigins;
        }
        //#endregion bankAccounts get

        //#region get collection cashes
        //#region old code
        // localData = {
        //     conditionals: [
        //         { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${buildingId}`, },
        //         { field: globalSettings?.collections?.properties?.inactive, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: false, },
        //     ],
        //     ordersBy: [
        //         { field: globalSettings?.collections?.properties?.description, value: 'asc', },
        //     ],
        //     buildingId,
        //     limit: limit,
        // };

        // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCollectionCashes}/`, localData, headerObj);
        // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCollectionCashes}/`, localData, headerObj);
        // response = result.data;

        // if (!response?.isSuccess || response?.isWarning) {
        //     return response;
        // }

        // let localCollectionCashes = response.result;
        // if (isUndefined(localCollectionCashes) || isNull(localCollectionCashes) || localCollectionCashes.length <= 0) {
        //     responseIsWarning.msgText = `${globalSettings?.messages?.youMustCreateLeastOneCollectionCash.es}<br/>`;
        //     responseIsWarning.msgText += `${globalSettings?.messages?.goTo.es}: <i class='${globalSettings?.icons?.collectionCash}'></i> `;
        //     responseIsWarning.msgText += `<a href='${globalSettings?.app?.backend?.urlCollectionCashes}'>${globalSettings?.labels?.collectionCashes.es}</a>`;
        //     return responseIsWarning;
        // }

        // if (valueReturn) {
        //     response.result = orderBy(response.result, 'description', 'asc');
        //     paymentData.collectionCashes = response.result;
        // }
        //#endregion old code

        response = await validationCollectionCashGetAsync({
            buildingId: buildingId,
            limit: limit,
            auth: auth,
            languageId: languageId,
            subMethod: currentMethod,
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        if (valueReturn) {
            response.result = response.result?.sort((a, b) => a?.[globalSettings?.collections?.properties?.description]?.toLowerCase() > b?.[globalSettings?.collections?.properties?.description]?.toLowerCase() ? 1 : -1);
            paymentData.collectionCashes = response.result;
        }
        //#endregion get collection cashes

        //#region final data set
        response.result = paymentData;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}